"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMSource = void 0;
var vue_property_decorator_1 = require("vue-property-decorator");
var vue_class_component_1 = require("vue-class-component");
var source_path_mixin_1 = require("./source-path-mixin");
// @ts-ignore
var VMSource = /** @class */ (function (_super) {
    __extends(VMSource, _super);
    function VMSource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VMSource.prototype.render = function () {
        var slotNodes = this.$scopedSlots.default({
            $source: this.$source
        });
        if (slotNodes.length !== 1) {
            throw new Error("Found " + slotNodes.length + " nodes in default slot for component 'vm-source'.");
        }
        return slotNodes[0];
    };
    VMSource = __decorate([
        vue_property_decorator_1.Component
    ], VMSource);
    return VMSource;
}((0, vue_class_component_1.mixins)(source_path_mixin_1.SourcePathMixin)));
exports.VMSource = VMSource;
